'use client'

import { usePage } from '@/components/providers/PageProvider'
import { createDynamicComponent } from '@/utils/factoryUtil'

import { FeaturedComboHeading } from '../FeaturedComboHeading/FeaturedComboHeading'
import { FeaturedComboStats } from '../FeaturedComboStats/FeaturedComboStats'

import styles from './FeaturedComboMetadata.module.scss'

const FeaturedComboMetadataGraph = createDynamicComponent({
  loader: () => import('./FeaturedComboMetadataGraph/FeaturedComboMetadataGraph'),
  name: 'FeaturedComboMetadataGraph',
})

export const FeaturedComboMetadata = () => {
  const { page } = usePage()
  const combo = page?.featuredCombo

  if (!combo) return null

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <FeaturedComboHeading heading='Combo Metadata' icon='chartSimple' />
      </div>
      <div className={styles.chartWrap}>
        <div className={styles.stats}>
          <FeaturedComboStats stats={['rank', 'deckTotal', 'inclusion']} />
        </div>
        <p className={styles.yAxisLabel}>Decks</p>
        <div className={styles.chart}>
          <FeaturedComboMetadataGraph />
        </div>
      </div>
      <p className={styles.xAxisLabel}>Combo Rank</p>
    </div>
  )
}
